import axios from "axios";
export default {
    getWorkSpaces: () => axios.post("/WorkSpaces/GetWorkSpaces", {})
};
